<script>
import Vue from "vue";
import APIService from "@/services/api.service";
import VueFileAgent from "vue-file-agent";
import "vue-file-agent/dist/vue-file-agent.css";

Vue.use(VueFileAgent);

export default {
	name: "FormImportUmat",
	data() {
		return {
			step: 1,
			info: {
				kk: 0,
				umat: 0,
				error: 0,
				judul: null,
			},
			uploadUrl: APIService.importDataUmat(),
			uploadHeaders: APIService.getHeader(),
			fileExcel: null,
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
	},
	created() {},
	mounted() {},
	methods: {
		onChecking: function () {
			if (this.fileExcel) {
				this.$refs.vueFileAgent.upload(
					this.uploadUrl,
					this.uploadHeaders,
					[this.fileExcel],
					function createFormData(fileData) {
						var formData = new FormData();
						formData.append("step", 1);
						formData.append("excel", fileData.file);
						return formData;
					}
				);
			} else {
				this.$toast.error("File Excel belum dipilih.");
			}
		},
		onSubmit() {
			this.$refs.vueFileAgent.upload(
				this.uploadUrl,
				this.uploadHeaders,
				[this.fileExcel],
				function createFormData(fileData) {
					var formData = new FormData();
					formData.append("step", 2);
					formData.append("excel", fileData.file);
					return formData;
				}
			);
		},
		onUpload(responses) {
			for (let response of responses) {
				// if (response.error) {
				// 	console.log("responseError", response);
				// 	continue;
				// }

				console.log("onUpload", response.data);

				this.info.umat = response.data.umat;
				this.info.kk = response.data.kk;
				this.info.error = response.data.error;
				this.info.judul = response.data.judul;

				if (response.data.step == 1) {
					this.step = 2;
					this.$modal.show("konfirmasiModal");
				} else {
					this.$toast.info("Import selesai");
					this.onReset();
				}
			}
		},
		onUploadError(failedResponses) {
			console.log("onUploadError", failedResponses);
		},
		onCancel() {
			this.onReset();
		},
		onReset() {
			this.$modal.hide("konfirmasiModal");
			this.step = 1;
			this.fileExcel = null;
		},
		onSelect: function (fileRecords) {
			console.log("onSelect", fileRecords);
			this.uploaded = false;
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs main="Data Umat" title="Import Data Umat" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-dropdown
										size="sm"
										variant="primary"
										right
										text="Menu"
									>
										<!-- <b-dropdown-item @click="downloadTemplate()"
											><small>Template Excel</small></b-dropdown-item
										>
										<b-dropdown-item @click="onProses()"
											><small>Proses</small></b-dropdown-item
										> -->
									</b-dropdown>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<div class="card-body">
					<div class="form theme-form">
						<div class="row">
							<div class="col-md-12">
								<VueFileAgent
									ref="vueFileAgent"
									:theme="'list'"
									:multiple="false"
									:deletable="false"
									:meta="true"
									:compact="true"
									:accept="'text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
									:maxSize="'20MB'"
									:maxFiles="1"
									:helpText="'(File Excel yang di upload harus sesuai dengan template. jika tidak akan mengakibatkan kerusakan data). Hanya support .xlsx atau Excel 2010 keatas'"
									:errorText="{
										type: 'Invalid file type',
										size: 'Files should not exceed 20MB in size',
									}"
									@upload="onUpload($event)"
									@upload:error="onUploadError($event)"
									@select="onSelect($event)"
									v-model="fileExcel"
                           
								></VueFileAgent>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 text-center">
                     <hr>
								<b-button
									variant="primary"
									@click="onChecking()"
									v-b-tooltip.hover
									title="Kirim"
									><i class="fa fa-upload"></i> Upload</b-button
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<modal
			name="konfirmasiModal"
			width="30%"
			height="auto"
			:clickToClose="false"
		>
			<template>
				<div class="myModal">
					<div class="row">
						<div class="col-md-12">
							<h5 class="text-center"><b>INFORMASI</b></h5>
							<br />
							<table class="table table-strip">
								<tr>
									<td>Nama</td>
									<td>:</td>
									<td>{{ info.judul }}</td>
								</tr>
								<tr>
									<td>Total Umat</td>
									<td>:</td>
									<td>{{ info.umat }}</td>
								</tr>
								<tr>
									<td>Total KK</td>
									<td>:</td>
									<td>{{ info.kk }}</td>
								</tr>
								<!-- <tr>
									<td>Data Bermasalah (error)</td>
									<td>:</td>
									<td>{{ info.error }}</td>
								</tr> -->
							</table>
						</div>
						<div class="col-md-12">
							<hr />
							<div class="text-right">
								<b-button
									class="mr-2"
									variant="outline-danger"
									@click="onCancel()"
									v-b-tooltip.hover
									title="Batal"
									><i class="fa fa-close"></i> Batal</b-button
								>
								<b-button
									variant="primary"
									@click="onSubmit()"
									v-b-tooltip.hover
									title="Kirim"
									><i class="fa fa-check"></i> Kirim</b-button
								>
							</div>
						</div>
					</div>
				</div>
			</template>
		</modal>
	</div>
</template>

<style scoped>
.myModal {
	padding: 20px;
	scroll-behavior: smooth;
}
::v-deep .vm--modal {
	overflow-y: auto;
}
.modal-card {
	margin: 0px;
}
</style>
